import './HeroTitle.css'

const HeroTitle = () => {
  return (
    <div className="hero__title-wrapper">
      <h1 className="hero__title">
        <span className="hero__title-letter">A</span>utomate your journey
        <br />
        in <span className="hero__title-highlight">TibiaME</span>
      </h1>
    </div>
  )
}

export default HeroTitle
